/**
 * Toast 组件 - H5 版本
 * 使用 zarm-v3 Toast
 *
 * 平台差异说明:
 * 1. 使用 zarm-v3 Toast 组件 (全文件)
 * 2. 小程序版本使用 Taro.showToast，见 index.mini.tsx
 *
 * 共享模块:
 * - 接口定义 ToastOptions 与小程序端保持一致
 * - 导出类名 ToastService 与 StaticToast 保持一致
 *
 * 最后更新: 2026-03-20
 * 更新原因: 明确 H5 端实现，配合 index.mini.tsx 实现真正的跨平台
 */
import { Toast as ZarmToast } from 'zarm-v3';

export interface ToastOptions {
  duration?: number;
  mask?: boolean;
}

/**
 * Toast 服务
 * 提供统一的 Toast API，兼容原 StaticToast 用法
 */
export class ToastService {
  /**
   * 显示成功提示
   */
  static success(content: string, _duration = 3000, _options?: ToastOptions) {
    ZarmToast.show(content);
  }

  /**
   * 显示错误提示
   */
  static error(content: string, _duration = 3000, _options?: ToastOptions) {
    ZarmToast.show(content);
  }

  /**
   * 显示警告提示
   */
  static warning(content: string, _duration = 3000, _options?: ToastOptions) {
    ZarmToast.show(content);
  }

  /**
   * 显示普通提示
   */
  static info(content: string, _duration = 3000, _options?: ToastOptions) {
    ZarmToast.show(content);
  }

  /**
   * 显示加载提示
   */
  static loading(content = '加载中...', _options?: ToastOptions) {
    ZarmToast.show(content);
  }

  /**
   * 隐藏 Toast
   */
  static hide() {
    ZarmToast.clear();
  }
}

/**
 * 兼容原 StaticToast 的导出
 */
export const StaticToast = ToastService;

export default ToastService;
